import { useEffect, useRef } from 'react';

/**
 * Gives access to the previous value (similar to prevProps or prevState)
 * https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
 * @param {*} value
 * @param {*} initialValue
 * @returns
 */
export const usePrevious = (value, initialValue) => {
  const ref = useRef(initialValue);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
